import * as React from "react";
import type { SVGProps } from "react";
const SvgMicrophone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 10 16"
    {...props}
  >
    <path
      stroke="#7B4BDD"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 12.5a4 4 0 0 0 4-4v-1m-4 5a4 4 0 0 1-4-4v-1m4 5V15m-2.5 0h5M5 10.5a2 2 0 0 1-2-2V3a2 2 0 1 1 4 0v5.5a2 2 0 0 1-2 2"
    />
  </svg>
);
export default SvgMicrophone;
